module.exports = __webpack_public_path__ + "static/media/accomodation.9849bd5d.jpg";